export default __webpack_public_path__ + "static/last-word_view-msg_banner_desktop-ef7bb7a8ffa2e79addf81f938d9455eb.png";